import { useEffect } from 'react'

import { useDocumentVisibility, useRequest } from 'ahooks'

import { shouldRefreshApi } from '@eastcoal/api/gateway/cipher/shouldRefresh'
import { AppInfo } from '@eastcoal/api/gateway/interface'

/**
 * 应用刷新 Hook：当接口返回需要刷新的标记时，自动刷新页面
 * 主要是用于应用版本更新时，强制用户刷新页面以获取最新代码，防止请求加密出现问题
 */
export const useAppRefreshSubscriber = (appInfo: AppInfo) => {
  const documentVisibility = useDocumentVisibility()

  const { data } = useRequest(
    () =>
      shouldRefreshApi(appInfo, {
        ignore401: true,
        silence: true
      }),
    {
      manual: false,
      ready: documentVisibility === 'visible',
      refreshDeps: [documentVisibility],
      cacheKey: 'app-should-refresh',
      staleTime: 1000 * 60 * 60 // 1 小时
    }
  )

  useEffect(() => {
    if (data) {
      window.location.reload()
    }
  }, [data])
}
